var _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Home") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "learner_dashboard_med",
    "data-name": "learner  dashboard_med",
    style: {
      isolation: "isolate"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 11,
    height: 11,
    rx: 3,
    fill: "inherit"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 11,
    height: 11,
    rx: 3,
    transform: "translate(13)",
    fill: "inherit"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 11,
    height: 11,
    rx: 3,
    transform: "translate(13 13)",
    fill: "inherit"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 11,
    height: 11,
    rx: 3,
    transform: "translate(0 13)",
    fill: "inherit"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.2794b90659a4e1cf1294dd87151f1f0e.svg";
export { ForwardRef as ReactComponent };